// TerminRow.tsx — eine Zeile der Dashboard-Termine (Termin oder TWV) und die
// Ganztägig-Pille. Aus `TermineWiedervorlagenCard.tsx` herausgelöst, seit das
// Tages-Popup (T-394, `DashTagPopup`) dieselben Zeilen zeigt.
import * as React from "react";
import { Clock16Regular, Video16Regular } from "@fluentui/react-icons";
import { REFINED } from "../risikoanalyseStep/tokens";

// Ganztägig-Kennzeichnung (Pille im StatusChip-Stil, aub-getönt) — ersetzt den
// bisherigen Text „Ganztägig" im Zeit-Slot bzw. in der Chip-Kopfzeile.
export const GanztaegigPill: React.FC = () => (
    <span
        style={{
            flexShrink: 0,
            display: "inline-flex",
            alignItems: "center",
            padding: "1px 8px",
            borderRadius: 999,
            backgroundColor: REFINED.aub50,
            color: REFINED.aub,
            fontSize: "0.68rem",
            fontWeight: 800,
            letterSpacing: "0.01em",
            whiteSpace: "nowrap",
        }}
    >
        Ganztägig
    </span>
);

/** Titel und Ort einer Zeile: einzeilig mit „…" oder (`voll`) umbrechend. */
const zeilenText = (voll: boolean): React.CSSProperties =>
    voll
        ? { whiteSpace: "normal", overflowWrap: "anywhere" }
        : { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };

export const Row: React.FC<{
    border: boolean;
    time: string;
    allDay?: boolean;
    dot: string;
    title: string;
    sub: string;
    chip: { kind: "termin"; online?: boolean } | { kind: "twv" };
    onClick?: (e: React.MouseEvent) => void;
    onDoubleClick?: () => void;
    /**
     * Titel und Ort ungekürzt, umbrechend — im Tages-Popup (T-394): dort ist
     * der volle Titel der Grund, den Tag zu öffnen.
     */
    voll?: boolean;
}> = ({ border, time, allDay, dot, title, sub, chip, onClick, onDoubleClick, voll = false }) => (
    <div
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        style={{
            display: "flex", alignItems: voll ? "flex-start" : "center", gap: 14,
            padding: "12px 6px",
            borderTop: border ? `1px solid ${REFINED.line}` : "none",
            cursor: onClick || onDoubleClick ? "pointer" : "default",
        }}
    >
        <span style={{ width: 52, flexShrink: 0, fontVariantNumeric: "tabular-nums", color: REFINED.ink2, fontWeight: 800, fontSize: "0.92rem" }}>{time}</span>
        <span style={{ width: 9, height: 9, borderRadius: 999, backgroundColor: dot, flexShrink: 0, marginTop: voll ? 6 : 0 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: voll ? "wrap" : "nowrap", gap: 7, minWidth: 0 }}>
                {allDay && <GanztaegigPill />}
                <span style={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: "0.95rem", color: REFINED.ink, ...zeilenText(voll) }}>{title}</span>
            </div>
            {sub && <div style={{ fontSize: "0.83rem", color: REFINED.ink2, ...zeilenText(voll) }}>{sub}</div>}
        </div>
        {chip.kind === "termin" ? (
            <span style={{ flexShrink: 0, display: "inline-flex", alignItems: "center", gap: 5, padding: "4px 11px", borderRadius: 999, backgroundColor: REFINED.aub50, color: REFINED.aub, fontSize: "0.78rem", fontWeight: 700, whiteSpace: "nowrap" }}>
                {chip.online && <Video16Regular />} Termin
            </span>
        ) : (
            <span style={{ flexShrink: 0, display: "inline-flex", alignItems: "center", gap: 5, padding: "4px 11px", borderRadius: 999, backgroundColor: "#fdf4e0", color: "#8a6d00", fontSize: "0.78rem", fontWeight: 700, whiteSpace: "nowrap" }}>
                <Clock16Regular /> TWV
            </span>
        )}
    </div>
);
